module.exports = __webpack_public_path__ + "assets/approved-wait.2b49b9dd.svg";